export default __webpack_public_path__ + "scene1_2_icon765fa5.png";